import React from 'react';
import PropTypes from 'prop-types';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '@/pages/dashboard-year/MetricLoader';
import DeltaMetric from '@/pages/dashboard-year/DeltaMetric';
import useCompletedEducatorEventEvaluations from '@/features/dashboard-eval/hooks/useCompletedEducatorEventEvaluations';
import useEducatorEventEvaluations from '@/features/dashboard-eval/hooks/useEducatorEventEvaluations';
import moment from 'moment-timezone';
import ComparisonMetric from '@/pages/dashboard-year/ComparisonMetric';

CompositeEducatorEventEvaluations.propTypes = {
  state: PropTypes.string,
  network: PropTypes.string,
  schoolStart: PropTypes.string,
  schoolEnd: PropTypes.string,
  titleOnly: PropTypes.bool,
  showTotals: PropTypes.bool
};

export default function CompositeEducatorEventEvaluations(props) {
  const { state, network, schoolStart, schoolEnd, titleOnly, showTotals = true } = props;

  const previousSchoolStart = titleOnly ? undefined : moment(schoolStart).subtract(1, 'year').toISOString();

  const totalEvaluations = useEducatorEventEvaluations({ state, network, schoolStart: undefined, schoolEnd });
  const previousEvaluations = useEducatorEventEvaluations({ state, network, schoolStart: previousSchoolStart, schoolEnd: schoolStart });
  const newEvaluations = useEducatorEventEvaluations({ state, network, schoolStart, schoolEnd });

  const totalEvaluationsCompleted = useCompletedEducatorEventEvaluations({ state, network, schoolStart: undefined, schoolEnd });
  const previousEvaluationsCompleted = useCompletedEducatorEventEvaluations({ state, network, schoolStart: previousSchoolStart, schoolEnd: schoolStart });
  const newEvaluationsCompleted = useCompletedEducatorEventEvaluations({ state, network, schoolStart, schoolEnd });

  if (
    totalEvaluations.state === PayloadStates.FETCHING ||
    previousEvaluations.state === PayloadStates.FETCHING ||
    newEvaluations.state === PayloadStates.FETCHING ||
    totalEvaluationsCompleted.state === PayloadStates.FETCHING ||
    previousEvaluationsCompleted.state === PayloadStates.FETCHING ||
    newEvaluationsCompleted.state === PayloadStates.FETCHING
  ) {
    return (
      <>
        {showTotals && (
          <>
            <MetricLoader
              name="Total educator event evaluations sent"
            />
            <MetricLoader
              name="Total educator event evaluations completed"
            />
          </>
        )}
        {!titleOnly && (
          <>
            <MetricLoader
              name="Educator event evaluations sent"
            />
            <MetricLoader
              name="Educator event evaluations completed"
            />
          </>
        )}
      </>
    );
  }

  return (
    <>
      {showTotals && (
        <>
          <DeltaMetric
            name="Total educator event evaluations sent"
            value={totalEvaluations.meta.totalCount}
            delta={newEvaluations.meta.totalCount}
            titleOnly={titleOnly}
          />
          <DeltaMetric
            name="Total educator event evaluations completed"
            value={totalEvaluationsCompleted.meta.totalCount}
            delta={newEvaluationsCompleted.meta.totalCount}
            titleOnly={titleOnly}
          />
        </>
      )}
      {!titleOnly && (
        <>
          <ComparisonMetric
            name="Educator event evaluations sent"
            value={newEvaluations.meta.totalCount}
            previousValue={previousEvaluations.meta.totalCount}
            titleOnly={titleOnly}
          />
          <ComparisonMetric
            name="Educator event evaluations completed"
            value={newEvaluationsCompleted.meta.totalCount}
            previousValue={previousEvaluationsCompleted.meta.totalCount}
            titleOnly={titleOnly}
          />
        </>
      )}
    </>
  );
}
